import { Box, Grid, Paper, Tab, Tabs, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const EndoscopyNav = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [value, setValue] = useState("/endoscopy");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const valid = ["/endoscopy", "/endoscopy/tests", "/endoscopy/patient-records"];
    if (valid.includes(location.pathname)) setValue(location.pathname);
    else setValue("/endoscopy");
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={(e, v) => {
              setValue(v);
              navigate(v);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "120px" },
            }}
          >
            <Tab
              style={{ ...tabStyle, backgroundColor: value === "/endoscopy" ? theme.palette.primary.main : "white", color: value === "/endoscopy" ? "white" : "black" }}
              label={t("endoscopy.dashboard", "Dashboard")}
              value="/endoscopy"
              component={NavLink}
              to="/endoscopy"
            />
            <Tab
              style={{ ...tabStyle, backgroundColor: value === "/endoscopy/tests" ? theme.palette.primary.main : "white", color: value === "/endoscopy/tests" ? "white" : "black" }}
              label={t("endoscopy.endoscopyType", "Endoscopy Type")}
              value="/endoscopy/tests"
              component={NavLink}
              to="/endoscopy/tests"
            />
            <Tab
              style={{ ...tabStyle, backgroundColor: value === "/endoscopy/patient-records" ? theme.palette.primary.main : "white", color: value === "/endoscopy/patient-records" ? "white" : "black" }}
              label={t("endoscopy.testResult", "Test Result")}
              value="/endoscopy/patient-records"
              component={NavLink}
              to="/endoscopy/patient-records"
            />
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default EndoscopyNav;
